import React from 'react'
import { Banner } from './banner_types'
import { BannerFrame, BannerImage } from './banner_frame'

/*
 * Side banners stack in API order outside the central page column.
 * Both rails have a fixed width; every image supplies its own natural height,
 * regardless of its aspect ratio or the number of banners on either side.
 */

interface SideBannerRailProps {
    side: 'left' | 'right'
    banners: Banner[]
}

export default function SideBannerRail({ side, banners }: SideBannerRailProps) {
    // An empty side renders no placeholder card.
    if (banners.length === 0) return null

    return (
        <aside className={`page-rail page-rail--${side}`}>
            {banners.map((banner, index) => (
                <BannerFrame key={banner.id} banner={banner} className="page-rail-item">
                    {/* The rail's first card is at the top of the page, so it
                        must not be deferred; only the ones stacked below can. */}
                    <BannerImage banner={banner}
                        eager={index === 0}
                        priority={index === 0 ? 'low' : undefined} />
                </BannerFrame>
            ))}
        </aside>
    )
}
